// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { yupResolver } from "@hookform/resolvers/yup";
import { notify } from "@/shared/utils/notify";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";

import { createProduct, setProductsForUpdate, refreshTableProducts, selectIsUpdateProduct, selectProductForUpdate, selectProductRefreshTable, setIsProductsForUpdate, updateProduct } from "../../../redux";
import { productVariantsService, productComboCategoriesService, productMediaService } from "../../../shared/services";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { TableProperties } from "../../../shared/components/ui/Table/types";
import { IProducts } from "../../../redux/@types";
import { validateCreateProducts, validateUpdateProducts } from "../../../helpers";
import moment from "moment";
import { productsService } from "../../../shared/services";
import { pendingProductMediaStore } from "../lib/pendingProductMediaStore";

interface PropsArray {
  [k: string]: number;
}

const helperObjQueryKey = {
  total_without_categories:         null,
  total_without_images:             'images',
  total:                            null,
  total_active:                     'status',
  total_inactive:                   'status',
  total_with_out_description_short: 'description_short',
  total_with_out_weight:            'weight',
  total_with_out_height:            'height',
  total_with_out_width:             'width',
  total_with_out_long:              'long',
}

const helperObjQueryVal = {
  total_without_categories:         `$or:[{category_id: 'null'},{category_id : 1}]`,
  total_without_images:             'false',
  total:                            null,
  total_active:                     'active',
  total_inactive:                   'inactive',
  total_with_out_description_short: 'null',
  total_with_out_weight:            'null',
  total_with_out_height:            'null',
  total_with_out_width:             'null',
  total_with_out_long:              'null',
}

export const useProducts = () => {
  const [querySelectorTransform, setQuerySelectorTransform] = useState< PropsArray>({})
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isUpdateProduct = useSelector(
    selectIsUpdateProduct
  );
  const dataUpdateProduct = useSelector(
    selectProductForUpdate
  );
  const isRefreshTableProducts = useSelector(
    selectProductRefreshTable
  );

  const [isLoading, setIsLoading] = useState(false);
  const [tableProps, setTableProps] = useState<TableProperties>();
  const [productsPremiun, setProductsPremiun] = useState<IProducts[]>([]);

  const navigateProductsCreate = () => {
    dispatch(setIsProductsForUpdate(false));
    navigate(`/products/new`);
  };

  const formMethodsCreate = useForm<IProducts>({
    resolver: yupResolver(validateCreateProducts),
    defaultValues: {
      is_combo: 'false',
      promo_entry_type: 'none',
      price: 0,
      price_with_tax: 0,
      discount_price: 0,
      discount_price_whit_tax: 0,
      quantity: 0,
      course: 'false',
      premium: 'false',
      sushi_almuerzo: 'false',
      multi_select_enabled: 'false',
      cashback_status: 'inactive',
    } as any,
  });

  const formMethodsUpdate = useForm<IProducts>({
    resolver: yupResolver(validateUpdateProducts),
  });

useEffect(() => {
    if (isUpdateProduct) {
      formMethodsCreate.reset();
      formMethodsUpdate.reset({
        ...dataUpdateProduct,
        promo_entry_type:
          (dataUpdateProduct as any)?.promo_entry_type || 'none',
        is_combo: (dataUpdateProduct as any)?.is_combo || 'false',
      });
    }

    return () => {
      formMethodsUpdate.reset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdateProduct, dataUpdateProduct]);

  const updateStatus = async(value: "active" | "inactive", id: any) =>{
    if (isLoading) return;
    setIsLoading(true);
    await updateProduct({
      id,
      status: value,
    })
    .then((res: Partial<IProducts>) => {
      setIsLoading(false);
      if (res.id) {
        // dispatch(bannersChangeModalState());
        notify.success(
          `Se ha actualizado con éxito el estado del producto con id:${res.id}`
        );
        dispatch(refreshTableProducts(true));
      } else {
        notify.error(res as string);
      }
    })
    .catch((err: any) => {
      setIsLoading(false);
      console.log(err);
      notify.error(err.message);
    });
  }

  const findAllProductsPremium = async(premium: string = 'true') =>{
    if (isLoading) return;
    setIsLoading(true);
    await productsService.find({
      query:{
        premium,
      }
    })
    .then((res: Partial<IProducts>) => {
      setIsLoading(false);
        setProductsPremiun(res.data)
    })
    .catch((err: any) => {
      notify.error(err.message);
    });
  }

// Reemplaza las categorías de combo del producto: borra existentes y recrea.
const persistComboCategories = async (productId: number, data: IProducts) => {
  const configs = (data.combo_category_configs || []).filter(
    (c: any) => c?.category_id > 0,
  );

  const existing = await productComboCategoriesService
    .find({ query: { product_id: productId, $limit: 200 } })
    .then((r: any) => r.data || r || [])
    .catch(() => []);
  for (const row of existing) {
    await productComboCategoriesService.remove(row.id).catch(() => {});
  }

  if ((data.is_combo || 'false').toString() !== 'true') return;

  const seenCategoryIds = new Set();
  let position = 0;
  for (let i = 0; i < configs.length; i++) {
    const cfg = configs[i];
    const categoryId = Number(cfg.category_id);
    if (!categoryId || seenCategoryIds.has(categoryId)) continue;
    seenCategoryIds.add(categoryId);

    await productComboCategoriesService
      .create({
        product_id: productId,
        category_id: categoryId,
        required_quantity: Number(cfg.required_quantity) || 1,
        position,
      })
      .catch(() => {});
    position += 1;
  }
};

const onSubmitCreateOrUpdate = async (data: IProducts) => {
    // console.log({ data });
    if (isLoading) return;
    setIsLoading(true);

    const promoEntryType = (data.promo_entry_type || 'none') as NonNullable<
      IProducts['promo_entry_type']
    >;
    const isPromoEntry = promoEntryType !== 'none';
    const isCombo = isPromoEntry ? 'false' : (data.is_combo || 'false').toString();
    const price = isPromoEntry ? 0 : data.price;
    const priceWithTax = isPromoEntry ? 0 : data.price_with_tax;
    const discountPrice = isPromoEntry ? 0 : data.discount_price;
    const discountPriceWithTax = isPromoEntry ? 0 : data.discount_price_whit_tax;

    if (isUpdateProduct) {
    // console.log("Actualiando===>", data);
      await updateProduct({
        id:data.id,
        name:data.name,
        code: data.code,
        category_id: isPromoEntry
          ? (null as any)
          : Number(data.category_id),
        ...(data.category_id_2  ? {category_id_2:  Number(data.category_id_2 )} : {}),
        ...(data.category_id_3  ? {category_id_3:  Number(data.category_id_3 )} : {}),
        brand_id: Number(data.brand_id),
        price,
        tax_rule_id: Number(data.tax_rule_id),
        discount_price: discountPrice,
        discount_price_whit_tax: discountPriceWithTax,
        price_with_tax: priceWithTax,
        quantity: data.quantity,
        cashback_status: data.cashback_status,
        ...(data.cashback_status === 'specific'  ? {cashback_specific_percentage: data.cashback_specific_percentage} : null),
        ...(data.quantity_per_unit_measure  ? {quantity_per_unit_measure:  data.quantity_per_unit_measure} : {}),
        ...(data.unit_measure  ? {unit_measure: data.unit_measure} : {}),
        weight: data.weight,
        heigh: data.heigh,
        width: data.width,
        long: data.long,
        ...(data.description  ? {description: data.description === "<p><br></p>" ? "" :data.description} : {}),
        status: data.status,
        position_more_sales: data.position_more_sales,
        user_guide_composition: data.user_guide_composition,
        user_guide_care: data.user_guide_care,
        discount_start_date_price: moment(data.discount_start_date_price),
        discount_end_date_price: moment(data.discount_end_date_price),
        course: data.course.toString(),
        premium: data.premium.toString(),
        sushi_almuerzo: data.sushi_almuerzo.toString(),
        multi_select_enabled: (data.multi_select_enabled || 'false').toString(),
        is_combo: isCombo,
        promo_entry_type: promoEntryType,
      })
        .then(async (res: Partial<IProducts>) => {
          setIsLoading(false);
          if (res.id) {
            const variantIds = data.variant_product_ids || [];
            const existing = await productVariantsService.find({
              query: { product_id: res.id, $limit: 500 },
            }).then((r: any) => r.data || []).catch(() => []);
            for (const v of existing) {
              await productVariantsService.remove(v.id).catch(() => {});
            }
            for (let i = 0; i < variantIds.length; i++) {
              await productVariantsService.create({
                product_id: res.id,
                variant_product_id: variantIds[i],
                position: i + 1,
              }).catch(() => {});
            }
            await persistComboCategories(res.id, {...data, is_combo: isCombo});
            notify.success(
              `Se ha actualizado con éxito el producto con id:${res.id}`
            );
            dispatch(setProductsForUpdate(res as any))
            dispatch(refreshTableProducts(true));
            navigate(`/products`);
          } else {
            notify.error(res as string);
          }
        })
        .catch((err: any) => {
          setIsLoading(false);
          console.log(err);
          notify.error(err.message);
        });
    } else {
      // console.log('Creando===>',data)
      // setIsLoading(false);
      const createPayload: Partial<IProducts> = {
        name: data.name,
        code: data.code,
        brand_id: Number(data.brand_id) || 1,
        price,
        tax_rule_id: Number(data.tax_rule_id) || 1,
        discount_price: discountPrice,
        price_with_tax: priceWithTax,
        discount_price_whit_tax: discountPriceWithTax,
        quantity: Number(data.quantity) || 0,
        description:
          data.description === '<p><br></p>' ? '' : data.description || '',
        position_more_sales: Number(data.position_more_sales) || 0,
        course: data.course ? data.course.toString() : 'false',
        multi_select_enabled: (data.multi_select_enabled || 'false').toString(),
        is_combo: isCombo,
        promo_entry_type: promoEntryType,
        cashback_status: data.cashback_status || 'inactive',
        premium: data.premium ? data.premium.toString() : 'false',
        sushi_almuerzo: data.sushi_almuerzo
          ? data.sushi_almuerzo.toString()
          : 'false',
      };

      if (isPromoEntry) {
        createPayload.category_id = null as any;
      } else {
        createPayload.category_id = Number(data.category_id) as any;
        if (data.category_id_2) {
          createPayload.category_id_2 = Number(data.category_id_2) || 1;
        }
        if (data.category_id_3) {
          createPayload.category_id_3 = Number(data.category_id_3) || 1;
        }
      }

      await createProduct(createPayload as IProducts)
        .then(async (res: any) => {
          setIsLoading(false);
          if (res.id) {
            const variantIds = data.variant_product_ids || [];
            for (let i = 0; i < variantIds.length; i++) {
              await productVariantsService.create({
                product_id: res.id,
                variant_product_id: variantIds[i],
                position: i + 1,
              }).catch(() => {});
            }
            await persistComboCategories(res.id, {...data, is_combo: isCombo});
            const pending = pendingProductMediaStore.getAll();
            if (pending.length > 0) {
              await Promise.all(
                pending.map((item, index) =>
                  productMediaService.create({
                    product_id: res.id,
                    type: item.type,
                    path: item.path || null,
                    url_youtube: item.url_youtube || null,
                    priority: item.priority ?? index,
                  })
                )
              ).catch(() => {});
              pendingProductMediaStore.clear();
            }
            dispatch(setProductsForUpdate(res));
            dispatch(setIsProductsForUpdate(true));
            notify.success(
              `Producto creado correctamente.`
            );
            dispatch(refreshTableProducts(true));
          } else {
            notify.error(res as any);
          }
        })
        .catch((err: any) => {
          setIsLoading(false);
          console.log(err);
          notify.error(err.message);
        });
    }
  };

  useEffect(() => {
    if (isRefreshTableProducts) {
      tableProps?.refresh();
      dispatch(refreshTableProducts(false));
    }
 // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isRefreshTableProducts]);

const handleQueryTransform = ( val: [] | string[])=>{
  if(val.length === 0){
    return setQuerySelectorTransform({})
  }
  else{
    const objAux: PropsArray= {}
    val.forEach((item)=>{
      if(helperObjQueryKey.hasOwnProperty(item) && item === 'total_without_categories'){
        return objAux['$or'] = [{category_id: 'null'},{category_id : 1}]
      } else if (helperObjQueryKey.hasOwnProperty(item)) {
        return objAux[helperObjQueryKey[item as keyof typeof helperObjQueryKey]] = helperObjQueryVal[item as keyof typeof helperObjQueryVal]
      }
    })
    return setQuerySelectorTransform(objAux)
  }
}

  return {
    //state
    querySelectorTransform,
    isUpdateProduct,
    isLoading,
    tableProps,
    //methods
    formMethodsCreate,
    formMethodsUpdate,
    productsPremiun,
    setTableProps,
    findAllProductsPremium,
    //functions
    navigateProductsCreate,
    onSubmitCreateOrUpdate,
    updateStatus,
    handleQueryTransform
  }
}
